__webpack_require__.p = "/schoolprojects/art-generator/";